/* @flow */

import * as React from 'react';
import { TweenMax, Power4 } from 'gsap';
import { withTheme } from 'glamorous';
import OnValueChange from '../commons/OnValueChange';

type Props = {
  children: React.Node,
  target?: React.Node | undefined,
  theme: Object,
  value: number
};

class AnimatePlayerRow extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    target: undefined
  };

  handleCallback = (currentValue, prevValue) => {
    const { target, theme } = this.props;

    if (this.tweenInstance) {
      this.tweenInstance.kill();
    }

    this.tweenInstance = TweenMax.fromTo(
      target,
      1,
      {
        color: theme.color.white,
        backgroundColor: currentValue > prevValue ? theme.color.green : theme.color.danger
      },
      {
        color: theme.color.basis1,
        backgroundColor: theme.color.white,
        delay: 5,
        ease: Power4.easeIn,
        clearProps: 'color,backgroundColor'
      }
    );
  };

  render() {
    const { children, value } = this.props;

    return (
      <OnValueChange value={value} callback={this.handleCallback}>
        {children}
      </OnValueChange>
    );
  }
}

export default withTheme(AnimatePlayerRow);
